// @ts-nocheck
import {BrowserRouter as Router, Routes, Route, Navigate} from "react-router-dom";
import {TicketSummary, RateSummary} from "views";
import {Configuration} from "core/configuration";
import {HeaderLayout} from "components/header-layout/HeaderLayout";

interface ITicketingProps {
  RouterComponent?: React.ComponentType;
  routerProps?: Record<string, string[]>;
}
const AppRoutes = ({RouterComponent = Router, routerProps = {}} : ITicketingProps): JSX.Element => {
  return (
    <div data-testid={Configuration.innerRootId} id={Configuration.innerRootId} >
      <RouterComponent {...routerProps}>
        <Routes>
          {/** Default Path redirect to Search */}
          <Route path="/" element={<Navigate to="unit" />} />
          
          <Route element={<HeaderLayout />}>
            {/* deprecate this routes eventually */}
            <Route path="unit" element={<TicketSummary />} />
            <Route path="unit/:unit_id" element={<TicketSummary />} />
            
            {/* new routes */}
            <Route path="unit/:unit_id/ticket-summary" element={<TicketSummary />} />
            <Route path="unit/:unit_id/rate-summary" element={<RateSummary />} />
          </Route>
          
          {/** Default Path redirect to Search */}
          <Route path="*" element={<Navigate to="/" />} />

        </Routes>
      </RouterComponent>
    </div>
  );
};

export default AppRoutes;
